export default "/images/ru-room-tour-mobile.png?0ce0354ce02c629d7fda23d9d6bfea47";